// extracted by mini-css-extract-plugin
module.exports =  {"placeholder":"InjectHtml-module__placeholder--dU","inline":"InjectHtml-module__inline--gi"};